import firebase from "firebase/compat/app";

const setChallengeInfo = async function(id, item) {
  let db = firebase.firestore();
  let result;
  if (id != undefined) {
    result = await db
      .collection("wellness_competition")
      .doc(id)
      .set(item, { merge: true });
  }
  return result;
};

export default setChallengeInfo;
